import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { FaEnvelope, FaArrowLeft } from 'react-icons/fa';
import './ResetPassword.css';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!email.trim()) {
      setError('Please enter your email address');
      return;
    }

    setIsSubmitting(true);
    setError('');
    setSuccessMessage('');

    try {
      await resetPassword(email);
      setSuccessMessage('Password reset instructions have been sent to your email address.');
      setEmail(''); // Clear form
    } catch (err) {
      setError('An error occurred. Please verify your email and try again.');
      console.error('Reset password error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="reset-password-container">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <Card className="reset-password-card">
            <Card.Body className="p-4">
              <div className="text-center mb-4">
                <h2 className="reset-password-title">Reset Password</h2>
                <p className="text-muted">Enter your email to receive reset instructions</p>
              </div>
              
              {error && <Alert variant="danger">{error}</Alert>}
              {successMessage && <Alert variant="success">{successMessage}</Alert>}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    disabled={isSubmitting}
                  />
                  <Form.Text className="text-muted">
                    We'll send a password reset link to this email address.
                  </Form.Text>
                </Form.Group>

                <Button 
                  variant="primary" 
                  type="submit" 
                  className="w-100 mb-3"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Reset Link'} <FaEnvelope className="ms-2" />
                </Button>
                
                <div className="text-center mt-3">
                  <Link to="/login" className="back-to-login">
                    <FaArrowLeft className="me-1" /> Back to Login
                  </Link>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;